import 'UI/Widget/Forms/ViewEditForm'
import '../Events'

/** @namespace Accounting.UI */
NS('Accounting.UI');

/**
 * @class
 * @extends UI.Widget.Forms.ViewEditForm
 */
Accounting.UI.ViewEditForm = Class(
    UI.Widget.Forms.ViewEditForm,
    Accounting.Events,
    /** @lends Accounting.UI.ViewEditForm.prototype */
    {
        /**
         * @inheritDoc
         */
        async save (silent) {
            application.ui.spinnerStart();

            try {
                const item = await this.Parent(true)

                if (!silent) {
                    this.emit("save", { item }, true);
                }

                return item
            } finally {
                application.ui.spinnerStop()
            }
        },
        /**
         * @inheritDoc
         */
        cancel(silent) {
            if (!this.Parent(true)) {
                return false;
            }

            this.$name("editor-buttons").hide();

            if (!silent) {
                this.emit("cancel", { item: this.item }, true);
            }
            return true;
        },
        /**
         * @inheritDoc
         */
        edit(silent) {
            if (!this.Parent(true)) {
                return false;
            }

            this.$name("editor-buttons").show();

            if (!silent) {
                this.emit("edit", { item: this.item }, true);
            }

            return true;
        }
    }
);
